import React, { useState } from 'react'
import { DatePicker, Uploader } from 'rsuite'
import CameraRetroIcon from '@rsuite/icons/legacy/CameraRetro'
import { ToastContainer, toast } from 'react-toastify'
import { SelectPicker, Stack } from 'rsuite';
import Axios from 'axios';
import { ApiEndPoint } from '../../Data/Api';
import moment from 'moment';
import Loader from '../../Components/Loader';
import { useSelector } from 'react-redux';
function MakePayment ({GetUserBooking,tentativebookins}) {
  // console.log(tentativebookins)
  const [transectionno, setTransectionno] = useState('');
  const [amount, setAmount] = useState('');
  const [errors, setErrors] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [date, setDate] = useState(new Date());
  const [isloading, setLoading] = useState(false);
  const [imageBase64, setImageBase64] = useState('');
  const [fileList, setFileList] = useState([]);
  const baseurl=ApiEndPoint();
  const UserDetail =useSelector((state) => state.user.user);
  // const data = tentativebookins.map(item => ({ label: item.invoice_no+'-'+item.lead_passenger, value: item.invoice_no}));
  const data = tentativebookins
  .filter(item => {
    const paymentDetails = JSON.parse(item.payment_details || "{}");
    return Object.keys(paymentDetails).length === 0; // Keep only items with empty payment_details
  })
  .map(item => ({
    label: `${item.invoice_no} - ${item.lead_passenger}`,
    value: item.invoice_no
  }));
  const handleChange = Selectedimg => {
    if (Selectedimg.length > 1) {
      const latestFile = Selectedimg.slice(-1)
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result; // Get the Base64 part only
        setImageBase64(base64);
      };
      reader.readAsDataURL(latestFile[0].blobFile);
      setFileList(latestFile)
    } else {
      if(Selectedimg.length === 0){
        setFileList(Selectedimg);
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result; // Get the Base64 part only
        setImageBase64(base64);
      };
      reader.readAsDataURL(Selectedimg[0].blobFile);
      setFileList(Selectedimg)
    }
  };
  const handledetailchange = event => {
    setTransectionno(event.target.value)
  };
  const handlechangeInvoicenumber = value => {
    setInvoiceNumber(value)
  };
  const handledatechange = value => {
    setDate(value)
  };
  
  const SubmitData=async()=>{
    let validation={};
    if(invoiceNumber===null){
      validation.invoiceNumber='Please Select Invoice Number.';
      setErrors(validation);
      return;
    }else if(date===null){
      validation.date='Please Select Date.';
      setErrors(validation);
      return;
    }else if(transectionno===''){
      validation.transectionno='Please Enter Transection Number.';
      setErrors(validation);
      return;
    }else if(fileList.length===0){
      validation.fileList='Please Select the Slip Image.';
      setErrors(validation);
      return;
    }
    setLoading(true);
    var req_data={
      'b2b_agent_id':UserDetail.id,
      'invoice_No':invoiceNumber,
      'payment_Date':moment(date).format('DD-MM-YYYY'),
      'transaction_No':transectionno,
      'payment_Image':JSON.stringify(imageBase64),
      // 'Paid_amount':amount
    }
    try {
      const response = await Axios.post(
        baseurl + '/api/hotels_Make_Payemnt',
        req_data
      );
      setLoading(false);
      if(response.data.status==='success'){
        toast.success(response.data.message)
        GetUserBooking();
        clearForm();
      }else{
        toast.error(response.data.message)
      }
      
    } catch (error) {
      setLoading(false);
      console.log(error);
      console.error('Error:', error);
    }
  }
  const clearForm=()=>{
    setInvoiceNumber(null);
    setTransectionno('');
    setFileList([]);
    setDate(new Date());
  }
  const handleamountchange=(event)=>{
    setAmount(event.target.value)
  }
  return (
    <>
    {isloading && (<Loader/>)}
    <ToastContainer/>
      <div className='agent-head'>
        <h5>Please upload payment details.</h5>
      </div>
      <div className='row'>
        <div class=' col-12 col-sm-12 col-md-6 mt-3'>
          <label className='fw-bold'>Invoice Number*</label>
            <SelectPicker onChange={handlechangeInvoicenumber} value={invoiceNumber}  name='invoicenumber' className='mt-2 ' placeholder='Select Invoice' data={data} style={{ width: '100%' }}/>
          {errors.invoiceNumber && (<p className='text-danger'>{errors.invoiceNumber}</p>)}
        </div>
        <div class=' col-12 col-sm-12 col-md-6 mt-3'>
          <label className='fw-bold'>Date*</label>
          <DatePicker
            format='dd-MM-yyyy'
            onChange={handledatechange}
            value={date}
            className='mt-2 d-block '
            oneTap
          />
        {errors.date && (<p className='text-danger'>{errors.date}</p>)}

        </div>
        <div class='form-group col-12 col-sm-12 col-md-6 mt-3'>
          <label className='fw-bold '>Transaction Number*</label>
          <input
            type='text'
            value={transectionno}
            onChange={handledetailchange}
            name='transectionno'
            class='form-control mt-2'
            placeholder='Enter Transaction Number'
          />
          {errors.transectionno && (<p className='text-danger'>{errors.transectionno}</p>)}
        </div>
        {/* <div class='form-group col-12 col-sm-12 col-md-6 mt-3'>
          <label className='fw-bold '>Paid Amount*</label>
          <input
            type='text'
            value={amount}
            onChange={handleamountchange}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            name='Paidamount'
            class='form-control mt-2'
            placeholder='Enter Paid Amount'
          />
           {errors.amount && (<p className='text-danger'>{errors.amount}</p>)}
        </div> */}
        <div class='form-group make_payment col-12 col-sm-12 col-md-12 mt-3'>
          <Uploader
            accept='.png, .jpg, .jpeg'
            draggable
            fileList={fileList}
            onChange={handleChange}
            multiple={false}
            listType='picture'
            autoUpload={false}
            action='//jsonplaceholder.typicode.com/posts/'
          >
            <button>
              <CameraRetroIcon />
            </button>
          </Uploader>
        </div>
        {errors.fileList && (<p className='text-danger'>{errors.fileList}</p>)}

      </div>
      <div className='text-center mt-3'>
        <button className='btn btn-success' onClick={SubmitData}>Submit Detail</button>
      </div>
    </>
  )
}
export default MakePayment
